import { observer } from "mobx-react";
import { FC } from "react";
import { MDateInput } from "@/components-v2/DateInput";
import { Dialog } from "@/components-v2/Dialog";
import { VBox } from "@/components-v2/Box";
import { MSelect } from "@/components-v2/Select";
import { MTextInput } from "@/components-v2/TextInput";
import { useTranslation } from "@/stores/RootStoreContext";
import { AddressForm, addressFormTitles, canSaveAddress } from "./companyAddressDomain";

export const AddressDialog: FC<{
  form: AddressForm;
  onCancel: () => void;
  onSave: () => void;
}> = observer(({ form, onCancel, onSave }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      title={t(addressFormTitles[form.addressType])}
      maxWidth={"sm"}
      onCancel={onCancel}
      onSubmit={onSave}
      isSubmitDisabled={!canSaveAddress(form)}
      submitLabel={t("save")}
    >
      <VBox gap={"md"}>
        <MTextInput
          model={form.addressLine1}
          label={{ key: "settings.company.addressLine1" }}
          autofocus
        />
        <MTextInput
          model={form.addressLine2}
          label={{ key: "settings.company.addressLine2" }}
          placeholder={{ key: "not-set" }}
        />
        <MTextInput model={form.postalCode} label={{ key: "settings.updateCompanyPostalCode" }} />
        <MTextInput model={form.postalPlace} label={{ key: "settings.updateCompanyPostalPlace" }} />
        <MSelect model={form.country} label={{ key: "settings.updateCompanyCountry" }} />
        <MDateInput model={form.effectiveFrom} label={{ key: "entity-data.effective-from" }} />
      </VBox>
    </Dialog>
  );
});
